export default "__VITE_ASSET__C0gOYSQ5__"